import { createContext } from 'react'
import { FileSystemItem } from 'shared-library/types'

export const DataContext = createContext({
    data: {} as FileSystemItem[],
    root: {} as FileSystemItem[],
    setData: (value: FileSystemItem[]) => { },
    setRoot: (value: FileSystemItem[]) => { }
})